import React, { useState } from "react";
import { Button, Container } from "reactstrap";
import useLocation from "../../components/user/Location/useLocation";
import Select from "react-select";
import Footer from "../../components/user/Footer";
import CardPay from "../../components/user/CardPay";
import "../user/style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { deleteData, getData, postDataJson } from "../../api/method";

const token = localStorage.getItem("token_key");
const username = localStorage.getItem("username");

function Pay() {
  const { state, onCitySelect, onDistrictSelect, onWardSelect, onSubmit } =
    useLocation(false);

  const {
    cityOptions,
    districtOptions,
    wardOptions,
    selectedCity,
    selectedDistrict,
    selectedWard,
  } = state;

  const today = new Date(),
    getDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

  const [error, setError] = useState({});
  const [address, setAddress] = useState("");
  const [date, setDate] = useState(getDate);
  const [total, setTotal] = useState();
  const [dataDetail, setDataDetail] = useState([]);
  const [dataUser, setDataUser] = useState([]);
  const [dataProduct, setDataProduct] = useState([]);

  const navigate = useNavigate();

  const validation = (e) => {
    const msg = {};

    if (address === "") {
      msg.address = "Address is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const getDataUser = async () => {
    try {
      const result = await getData(`/api/User/${username}`);
      setDataUser(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getDataDetail = async () => {
    try {
      const result = await getData(`/api/Cart/detail/${username}`);
      setDataDetail(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getDataProduct = async () => {
    try {
      const result = await getData(`/api/Cart/user/${username}`);
      setDataProduct(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataUser();
    getDataDetail();
    getDataProduct();

    const t = dataProduct.reduce((i, item) => {
      return (i +=
        (item.quantity * (item.product.price * (100 - item.product.discount))) /
        100);
    }, 0);

    setTotal(t);
  }, [dataProduct]);

  const handleDelete = async () => {
    try {
      const res = await deleteData(`/api/Cart/cart/${username}`);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmitPay = async () => {
    const isValid = validation();

    let order = {
      id: 0,
      date: new Date(date).toISOString(),
      totalPrice: total,
      status: 0,
      address: address,
      ward: selectedWard.label,
      district: selectedDistrict.label,
      city: selectedCity.label,
      userId: username,
      orderDetailQueries: dataDetail,
    };

    let strBody = JSON.stringify(order);

    if (isValid) {
      try {
        const res = await postDataJson("/api/Order", strBody)
        if (res.status === 200) {
          toast.success("Order success!");
          navigate("/");
          handleDelete();
        }
      } catch (err) {
        console.log(err);
        toast.error("Order fail!");
      }
    }
  };

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">Pay</p>
      </div>

      <div className="py-5">
        <Container className="d-flex">
          <div className="w-50 pe-5">
            <h3 className="fs-1 fw-bold text-center mb-5">Pay</h3>

            <div className="mt-3 d-flex">
              <div className="w-50 me-2">
                <div>
                  <label className="mb-2">Last Name</label>
                  <input
                    className="fs-6 border_input w-100"
                    placeholder="Last Name"
                    type="text"
                    value={dataUser.lastname}
                  />
                </div>

                {error.lastname && (
                  <p className="text-start error">{error.lastname}</p>
                )}
              </div>

              <div className="w-50 ms-2">
                <div>
                  <label className="mb-2">First Name</label>
                  <input
                    className="fs-6 border_input w-100"
                    placeholder="First Name"
                    type="text"
                    value={dataUser.firstname}
                  />
                </div>

                {error.firstname && (
                  <p className="text-start  error">{error.firstname}</p>
                )}
              </div>
            </div>

            <div className="mt-3 w-100">
              <label className="mb-2">Phone</label>
              <input
                className="fs-6 border_input w-100"
                placeholder="Phone"
                type="text"
                value={dataUser.phone}
              />

              {error.phone && <p className="text-start error">{error.phone}</p>}
            </div>

            <div className="mt-3">
              <label className="mb-2">Address</label>
              <div className="mb-3">
                <input
                  className="fs-6 border_input w-100"
                  placeholder="House number"
                  type="text"
                  name="address_number"
                  onChange={(e) => setAddress(e.target.value)}
                  onKeyUp={handleKeyUp}
                />
              </div>

              <div className="d-flex justify-content-between">
                <div className="d-flex w-30">
                  <Select
                    name="cityId"
                    key={`cityId_${selectedCity?.value}`}
                    isDisabled={cityOptions.length === 0}
                    options={cityOptions}
                    onChange={(option) => onCitySelect(option)}
                    placeholder="Tỉnh/Thành"
                    defaultValue={selectedCity}
                    className="w-100 fs-6 h-40 p-0 border_input"
                    styles={bgStyles}
                  />
                </div>

                <div className="d-flex w-30">
                  <Select
                    name="districtId"
                    key={`districtId_${selectedDistrict?.value}`}
                    isDisabled={districtOptions.length === 0}
                    options={districtOptions}
                    onChange={(option) => onDistrictSelect(option)}
                    placeholder="Quận/Huyện"
                    defaultValue={selectedDistrict}
                    className="w-100 fs-6 h-40 p-0 border_input"
                    styles={bgStyles}
                  />
                </div>

                <div className="d-flex w-30">
                  <Select
                    name="wardId"
                    key={`wardId_${selectedWard?.value}`}
                    isDisabled={wardOptions.length === 0}
                    options={wardOptions}
                    placeholder="Phường/Xã"
                    onChange={(option) => onWardSelect(option)}
                    defaultValue={selectedWard}
                    className="w-100 fs-6 h-40 p-0 border_input"
                    styles={bgStyles}
                  />
                </div>
              </div>

              {error.address && (
                <p className="text-start error">{error.address}</p>
              )}
            </div>

            <div className="d-flex justify-content-center">
              <Button
                className="btn_custom mt-5 w-50"
                onClick={() => handleSubmitPay()}
              >
                Order
              </Button>
            </div>
          </div>

          <div className="border_center"></div>

          <div className="w-50 ps-5">
            <div>
              <CardPay data={dataProduct} />
            </div>

            <div className="total_ship">
              <div className="border_bottom_pay p-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fs-20">Subtotal</span>
                  <span className="fs-20 fw-bold">
                    {(total * 1).toLocaleString("vi")}&#273;
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <span className="fs-20">Shipping</span>
                  <span className="fs-20 fw-bold">Free</span>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-2 p-3">
                <span className="fs-20 fw-bold">TOTAL</span>
                <span className="fs-20 fw-bold t-primary">
                  {(total * 1).toLocaleString("vi")}&#273;
                </span>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default Pay;

const bgStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // console.log({ data, isDisabled, isFocused, isSelected });
    return {
      ...styles,
      backgroundColor: isFocused ? "#ddd6d6cc" : null,
    };
  },
};
